var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPreferencesIconGrey(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 27.659,
    height: 30.377,
    viewBox: "0 0 27.659 30.377",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_775",
    "data-name": "Rectangle 775",
    width: 27.659,
    height: 30.377,
    fill: "#989898",
    stroke: "#989898",
    strokeWidth: 1
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_567",
    "data-name": "Group 567",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_566",
    "data-name": "Group 566",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5344",
    "data-name": "Path 5344",
    d: "M25.4,10.883H22.757a3.8,3.8,0,0,0-7.4,0H1.6a.85.85,0,1,0,0,1.7H15.355a3.8,3.8,0,0,0,7.4,0H25.4a.85.85,0,1,0,0-1.7m-6.351,2.95a2.1,2.1,0,1,1,2.1-2.1,2.1,2.1,0,0,1-2.1,2.1",
    transform: "translate(0.327 3.455)",
    fill: "#989898",
    stroke: "#989898",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5345",
    "data-name": "Path 5345",
    d: "M25.4,10.883H22.757a3.8,3.8,0,0,0-7.4,0H1.6a.85.85,0,1,0,0,1.7H15.355a3.8,3.8,0,0,0,7.4,0H25.4a.85.85,0,1,0,0-1.7Zm-6.351,2.95a2.1,2.1,0,1,1,2.1-2.1A2.1,2.1,0,0,1,19.053,13.833Z",
    transform: "translate(0.327 3.455)",
    fill: "#989898",
    stroke: "#989898",
    strokeMiterlimit: 10,
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5346",
    "data-name": "Path 5346",
    d: "M1.6,5.4H3.9a3.8,3.8,0,0,0,7.4,0H25.4a.85.85,0,1,0,0-1.7H11.3a3.8,3.8,0,0,0-7.4,0H1.6a.85.85,0,1,0,0,1.7M7.606,2.45a2.1,2.1,0,0,1,2.1,2.1,2.1,2.1,0,0,1-4.2,0,2.1,2.1,0,0,1,2.1-2.1",
    transform: "translate(0.327 0.326)",
    fill: "#989898",
    stroke: "#989898",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5347",
    "data-name": "Path 5347",
    d: "M1.6,5.4H3.9a3.8,3.8,0,0,0,7.4,0H25.4a.85.85,0,1,0,0-1.7H11.3a3.8,3.8,0,0,0-7.4,0H1.6a.85.85,0,1,0,0,1.7ZM7.606,2.45a2.1,2.1,0,0,1,2.1,2.1,2.1,2.1,0,0,1-4.2,0A2.1,2.1,0,0,1,7.606,2.45Z",
    transform: "translate(0.327 0.326)",
    fill: "#989898",
    stroke: "#989898",
    strokeMiterlimit: 10,
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5348",
    "data-name": "Path 5348",
    d: "M25.406,18.066H15.08a3.8,3.8,0,0,0-7.4,0H1.6a.85.85,0,1,0,0,1.7h6.08a3.8,3.8,0,0,0,7.4,0H25.406a.85.85,0,1,0,0-1.7m-14.028,2.95a2.1,2.1,0,1,1,2.1-2.1,2.1,2.1,0,0,1-2.1,2.1",
    transform: "translate(0.327 6.584)",
    fill: "#989898",
    stroke: "#989898",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5349",
    "data-name": "Path 5349",
    d: "M25.406,18.066H15.08a3.8,3.8,0,0,0-7.4,0H1.6a.85.85,0,1,0,0,1.7h6.08a3.8,3.8,0,0,0,7.4,0H25.406a.85.85,0,1,0,0-1.7Zm-14.028,2.95a2.1,2.1,0,1,1,2.1-2.1A2.1,2.1,0,0,1,11.377,21.016Z",
    transform: "translate(0.327 6.584)",
    fill: "#989898",
    stroke: "#989898",
    strokeMiterlimit: 10,
    strokeWidth: 1.5
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPreferencesIconGrey);
export default __webpack_public_path__ + "static/media/preferences-icon-grey.1c7cfdea54d1091e05dbd4a0b21d22c7.svg";
export { ForwardRef as ReactComponent };